// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".author~.author[data-v-1f8f05c6]::before{content:\", \"}[data-v-1f8f05c6] .related-collections.container{padding:0}[data-v-1f8f05c6] .related-collections .badge-pill{margin-top:.25rem;margin-right:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
